import type { FC } from "react";

import type { ProductAttribute } from "@locators/components/StoreLocator";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { HeaderItem } from "./HeaderItem";

import styles from "../StoreDetailsProductsByBrand.module.scss";

type AdditionalProductsProps = {
  items?: ProductAttribute[];
  iconContainerClassName?: string;
  isHelperTipEnabled?: boolean;
  groupName: string;
};

export const AdditionalProducts: FC<AdditionalProductsProps> = ({
  items,
  iconContainerClassName,
  isHelperTipEnabled = false,
  groupName,
}) => {
  const { __ } = useTranslations();

  if (!items?.length) {
    return null;
  }

  return (
    <>
      {isHelperTipEnabled && (
        <p className={styles.storeDetailsProductsHelper}>
          {__("store_locator.store_details.vending_machine_helper_tip")}
        </p>
      )}
      {items.map((item) => (
        <HeaderItem key={item.key} item={item} iconContainerClassName={iconContainerClassName} groupName={groupName} />
      ))}
    </>
  );
};
